// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-aug {
  box-shadow: 2px 2px 14px 2px rgba(0, 0, 0, 0.1);
  border: none !important;
}
.card-aug .ref-txt {
  font-size: 14px;
  font-family: "Barlow";
  font-weight: 400;
  color: rgb(125, 119, 121);
}
.card-aug .card-img-top {
  border-bottom: 1px solid rgb(234, 234, 234) !important;
}
.card-aug .noteCommande {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-aug.historique.card {
  min-height: 146px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/card.scss"],"names":[],"mappings":"AAAA;EACI,+CAAA;EACA,uBAAA;AACJ;AAAI;EACI,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;AAER;AACI;EACI,sDAAA;AACR;AACI;EACI,oBAAA;EACL,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AACH;;AAEA;EACI,iBAAA;AACJ","sourcesContent":[".card-aug{\n    box-shadow: 2px 2px 14px 2px rgba(0, 0, 0, 10%);\n    border: none !important;\n    .ref-txt{\n        font-size: 14px;\n        font-family: \"Barlow\";\n        font-weight: 400;\n        color: rgba(125, 119, 121, 1);\n        \n    }\n    .card-img-top{\n        border-bottom: 1px solid rgba(234, 234, 234, 1) !important;\n    }\n    .noteCommande{\n        display: -webkit-box;\n   -webkit-line-clamp: 2;\n   -webkit-box-orient: vertical;\n   overflow: hidden;\n   text-overflow: ellipsis;\n    }\n}\n.card-aug.historique.card{\n    min-height:146px ;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
